import {Tooltip} from 'bootstrap';
import 'bootstrap-slider';
import _slider from './_slider';
import {isNumeric, isTouchDevice} from '../common/_globals';

class RatingSlider {

    protected _lastShowTooltipTime: Date;

    protected initialized: boolean = false;

    public initOnce(forceInit: boolean = false): void {

        if (this.initialized && !forceInit) {
            return;
        }
        this.initialized = true;
        _slider.initOnce();

        const _this = this;
        $(function () {

            /**
             * The time when a slider option was changed latest.
             */
            _this._lastShowTooltipTime = new Date();

            // Init sliders
            $('.rating-slider .bootstrap-slider').each(function () {
                const values = $(this).data("slider-values");
                const itemElementID = $(this).data("item-element-id");
                const min = $(this).data("slider-min");
                const max = $(this).data("slider-max");
                const step = $(this).data("slider-step");
                const missingOptions = $(this).data("missing-options");
                const hiddenOptionsPrefix = $(this).data("hidden-options-prefix") || 'hidden-option-label-';
                const ticks = [];
                const tickLabels = [];
                const $containerElement = $(this).closest('.slider');
                $containerElement.data('hidden-options-prefix', hiddenOptionsPrefix);
                for (let tick = min; tick <= max; tick += step) {
                    ticks.push(tick);
                    tickLabels.push(_this.getOptionLabel($containerElement, tick));
                }
                const slider: JQuery = _slider.bootstrapSlider($(this), [{
                    // Don't use the slider's default tooltip but the custom one specified below
                    tooltip: 'hide',
                    ticks: ticks
                }]);
                const sliderElement = _slider.bootstrapSlider(slider, ['getElement']);

                // Set current value
                const $inputElement = $('#' + itemElementID, $(this).closest('.slider-column'));
                const hasValue = isNumeric($inputElement.val());
                if (hasValue) {
                    // Apply value that is already set
                    const valueIndex = _this.getValueIndex(values, <number>$inputElement.val());
                    _slider.bootstrapSlider(slider, ['setValue', valueIndex]);
                } else {
                    _slider.hideHandle(slider);
                    _slider.bootstrapSlider(slider, ['setValue', min]);
                }

                // Missing values
                $.each(missingOptions, function (key, missingOption: number) {
                    const $missingOptionTick = $('.slider-tick', sliderElement).eq(missingOption);
                    $missingOptionTick.addClass('option-tick-missing-value');
                });

                // Use custom bootstrap tooltip instead of the default tooltip of the slider,
                // because the slider's default tooltip doesn't support the required features (i.e. html).
                const $sliderHandle = $('.min-slider-handle', sliderElement);
                // Tooltip for slider handle
                new Tooltip($sliderHandle[0], {
                    container: '#' + sliderElement.id + ' .min-slider-handle',
                    placement: 'top',
                    trigger: 'manual',
                    html: true,
                    delay: 0
                });
                // Make sure to show the handle's tooltip if it's in use
                let isHandleTooltipShown = false;
                $sliderHandle.on('hide.bs.tooltip', function () {
                    // Use 'visually-hidden' as helper to hide tooltip immediatly
                    $('.tooltip', $sliderHandle).addClass('visually-hidden');
                }).on('hidden.bs.tooltip', function () {
                    isHandleTooltipShown = false;
                }).on('shown.bs.tooltip', function () {
                    isHandleTooltipShown = true;
                }).on('inserted.bs.tooltip', function () {
                    // Remove helper class, that was inserted above
                    $('.tooltip', $sliderHandle).removeClass('visually-hidden');
                });
                // Reload handle tooltip for the first time in order to initialize
                _this.reloadHandleTooltip(slider);
                _slider.hideHandleTooltip(slider);

                const $sliderRow = $(sliderElement).closest('.item-row');
                if (isTouchDevice()) {
                    _slider.resetOnSwipe();
                } else {
                    // Tooltips for slider ticks
                    let tickIndex = 0;
                    $('.slider-tick', sliderElement).each(function () {
                        if (_this.hasOptionLabel($containerElement, tickIndex)) {
                            const $tickElement = $(this);
                            const sliderTickId = 'slider-tick-' + sliderElement.id + '-' + tickIndex;
                            $tickElement.attr('id', sliderTickId);
                            new Tooltip(this, {
                                container: '#' + sliderTickId,
                                placement: 'top',
                                trigger: 'hover',
                                html: true,
                                title: _this.getOptionLabel($containerElement, tickIndex)
                            });
                            $tickElement.on('show.bs.tooltip', function () {
                                // Hide the tooltip of the handle if a tooltip of a tick is shown
                                _slider.hideHandleTooltip(slider);
                            }).on('click touchstart', function () {
                                _slider.hideHandleTooltip(slider);
                            }).on('mouseenter mouseleave', function () {
                                $('.tooltip', $tickElement).on('mouseenter mouseleave', function () {
                                    Tooltip.getInstance($tickElement[0]).hide();
                                });
                            });
                        }
                        tickIndex++;
                    });

                    // Show tooltip on 'mouseenter' and hide on 'mouseleave'
                    $sliderRow.on('mouseenter', function () {
                        if (!_slider.isHandleHidden(slider)) {
                            _this.showHandleTooltip(slider);
                        }
                    }).on('mouseleave focusout', function () {
                        _slider.hideHandleTooltip(slider);
                    });
                    $sliderHandle.on('mouseenter', function () {
                        // Make sure the handle's tooltip is shown
                        if (!isHandleTooltipShown) {
                            _this.showHandleTooltip(slider);
                        }
                    });
                }

                slider.on('slideStart', function (event: JQuery.Event) {
                    const value = (<any>event).value;
                    _slider.onSlideStart(slider, sliderElement, $sliderHandle, $sliderRow, min, value);
                    if (!isHandleTooltipShown && _this.hasOptionLabel($containerElement, value)) {
                        _this.showHandleTooltip(slider);
                    }
                }).on('change', function () {
                    _this._lastShowTooltipTime = new Date();
                    if (_this.hasOptionLabel($containerElement, _slider.bootstrapSlider(slider, ['getValue']))) {
                        _this.reloadHandleTooltip(slider);
                        _this.showHandleTooltip(slider);
                    } else if (isHandleTooltipShown) {
                        _slider.hideHandleTooltip(slider);
                    }
                    _slider.setValue(slider, _this.getValue(slider));
                    _this.setHandleTooltipTimeout(slider);
                }).on('slideStop', function () {
                    _slider.sliderIsSliding(false);
                });
            });
        });
    }

    public resetRatingSliderInput($ratingSlider: JQuery) {
        const itemElementID = $ratingSlider.data("item-element-id");
        const $inputElement = $('#' + itemElementID, $ratingSlider.closest('.slider-column'));
        $inputElement.val('');
    }

    protected showHandleTooltip(slider: JQuery): void {
        this._lastShowTooltipTime = new Date();
        const $containerElement = $('.slider', slider.closest('.survey-element'));
        if (this.hasOptionLabel($containerElement, _slider.bootstrapSlider(slider, ['getValue']))) {
            const $sliderHandle = $('.min-slider-handle', _slider.bootstrapSlider(slider, ['getElement']));
            Tooltip.getInstance($sliderHandle[0]).show();
            // Hide tooltip on mouse hover
            if (!isTouchDevice()) {
                $('.tooltip', $sliderHandle).on('mouseenter mouseleave', function () {
                    _slider.hideHandleTooltip(slider);
                });
            }
            this.setHandleTooltipTimeout(slider);
        }
    }

    /**
     * Hides tooltip automatically after timeout
     */
    protected setHandleTooltipTimeout(slider: JQuery): void {
        const tooltipTimeout = 2000;
        const _this = this;
        setTimeout(function () {
            const now: Date = new Date();
            if (<number><any>now - <number><any>_this._lastShowTooltipTime >= tooltipTimeout) {
                _slider.hideHandleTooltip(slider);
            }
        }, tooltipTimeout);
    }

    protected reloadHandleTooltip(slider: JQuery): void {
        const $sliderHandle = $('.min-slider-handle', _slider.bootstrapSlider(slider, ['getElement']));
        const $containerElement = $('.slider', slider.closest('.survey-element'));
        const index = _slider.bootstrapSlider(slider, ['getValue']);
        const optionLabel = this.getOptionLabel($containerElement, index);
        $sliderHandle.attr('data-bs-original-title', optionLabel);
    }

    protected getValue(slider: JQuery): number {
        const $sliderElement = slider.closest('.bootstrap-slider');
        const values = $sliderElement.data("slider-values");
        const index = _slider.bootstrapSlider(slider, ['getValue']);
        return parseInt(values[index]);
    }

    protected hasOptionLabel($containerElement: JQuery, index: number): boolean {
        const prefix = $containerElement.data('hidden-options-prefix') || 'hidden-option-label-';
        const optionLabelHtml = $('#' + prefix + index + ' span', $containerElement).html();
        return optionLabelHtml ? optionLabelHtml.length > 0 : false;
    }

    protected getOptionLabel($containerElement: JQuery, index: number): string {
        const prefix = $containerElement.data('hidden-options-prefix') || 'hidden-option-label-';
        const $optionLabel = $('#' + prefix + index, $containerElement);
        return $optionLabel.html() || '';
    }

    protected getValueIndex(values: number[], value: number): number {
        for (let index = 0; index < values.length; index++) {
            if (values[index] === value) {
                return index;
            }
        }
        return -1;
    }
}

export default new RatingSlider();